export default () => {
  const href = window.location.href;
  const hash = window.location.hash;

  // for tsiklevka-parketa landing
  if (href.indexOf('tsiklevka-parketa') !== -1) {
    if (hash === '#works-price') {
      document.querySelector('.collapse.works-price__collapse').classList.add('collapse_open');
    }

    if (hash === '#guarantee') {
      const items = Array.from(document.querySelectorAll('.health-care__item'));
      let timeout = 250;

      items.forEach(item => {
        setTimeout(() => {
          item.classList.add('health-care__item_animate');
        }, timeout += 250);
      })
    }
  }
}


// WEBPACK FOOTER //
// ./templates/floor/assets/js/jQueryApplication/esm/page-specific.js